var _path, _g, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApplyCreate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 0C7.83501 0 0 7.83501 0 17.5C0 27.1649 7.83501 35 17.5 35C27.1649 35 35 27.1649 35 17.5C35 7.83501 27.1649 0 17.5 0ZM16.1479 11.4958L12.6216 14.304C11.1422 15.4821 10.4024 16.0713 10.5468 16.7289L10.5545 16.7615C10.719 17.4151 11.6567 17.6664 13.532 18.169C14.5742 18.4482 15.0953 18.5878 15.3398 18.9828L15.3522 19.0036C15.5881 19.4033 15.4539 19.904 15.1856 20.9053L15.1154 21.167C14.3715 23.9431 13.9996 25.3311 14.7159 25.7794C15.4322 26.2276 16.572 25.3201 18.8515 23.505L22.3778 20.6967C23.8572 19.5186 24.597 18.9296 24.4526 18.2717L24.4451 18.2392C24.2804 17.5856 23.3427 17.3343 21.4674 16.8319C20.4253 16.5526 19.9042 16.4129 19.6597 16.0179L19.6473 15.9971C19.4114 15.5974 19.5456 15.0967 19.8139 14.0955L19.884 13.8337C20.6278 11.0576 20.9998 9.66957 20.2834 9.22129C19.5671 8.77303 18.4273 9.68063 16.1479 11.4958Z",
    fill: "url(#paint0_linear_26286_52276)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_26286_52276)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 40C24.477 40 20 35.523 20 30C20 24.477 24.477 20 30 20C35.523 20 40 24.477 40 30C40 35.523 35.523 40 30 40Z",
    fill: "white",
    fillOpacity: 0.25
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7867 34.7534L32.1938 32.3661C32.2679 32.2668 32.3703 32.1928 32.4885 32.1518L35.1988 31.5814C35.5896 31.4474 35.7408 30.9747 35.4982 30.6391L33.6482 28.5937C33.5773 28.496 33.5379 28.381 33.5316 28.2613L33.7018 25.5872C33.6845 25.1948 33.3079 24.9191 32.9281 25.0215L30.4652 26.175C30.3628 26.2033 30.2541 26.2033 30.1501 26.1765L27.6162 25.0436C27.2396 24.9443 26.8678 25.2169 26.8473 25.6045L26.9655 28.3006C26.9592 28.4125 26.9229 28.5213 26.8583 28.6142L25.1076 30.6533C24.8792 30.9873 25.0304 31.4459 25.4102 31.5798L28.1315 32.1534C28.2418 32.1928 28.3395 32.2621 28.412 32.3551L29.8097 34.7644C30.0587 35.0827 30.544 35.078 30.7867 34.7534Z",
    fill: "url(#paint1_linear_26286_52276)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_26286_52276",
    x: 11.1854,
    y: 11.1854,
    width: 37.6292,
    height: 37.6292,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4.4073
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_26286_52276"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_26286_52276",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26286_52276",
    x1: -0.729166,
    y1: -4.19271,
    x2: 34.8177,
    y2: 35.5469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86DCF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#746EF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26286_52276",
    x1: 25,
    y1: 25.7813,
    x2: 34.5697,
    y2: 34.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplyCreate);
export default __webpack_public_path__ + "static/media/apply-create.7dcf21c51a2dd5406b6809fd41873f60.svg";
export { ForwardRef as ReactComponent };